




























































































































import axios from "axios";
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog, QEditor } from "quasar";
import { notifyError, notifySuccess } from "@/common/notify";

import { Term, TermAttachment, Section } from "@/interfaces";
import { TermsManagementModule } from "@/store";
import FilePicker from "@/components/FilePicker.vue";

const defaultTerm: Term = {
  id: 0,
  title: "",
  content: "",
  attachments: [],
  sections: [],
};

const defaultTermAttachment: TermAttachment = {
  id: 0,
  filename: "Test",
  file: "",
};

@Component({
  components: {
    FilePicker,
  },
})
export default class DomainDialog extends Vue {
  @Ref("new-term-dialog")
  dialog!: QDialog;

  @Ref("file-picker-tpt")
  filePicker!: FilePicker;

  @Ref("editor_ref")
  editor_ref!: QEditor;

  @Ref("input_ref")
  input_ref!: HTMLInputElement;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: Object, required: false })
  term!: Term;

  @TermsManagementModule.bindings.State
  sections!: Section[];

  termData: Term = { ...defaultTerm };

  attachments: TermAttachment[] = [];

  removedAttachments: number[] = [];

  file: any = null;

  loading = false;

  progress = 0;

  showProgress = false;

  // Keeps track of the number of attachments. Gets valorized onComponentCreated
  attachmentsNumber = 0;

  // Source of the cancel token used to abort the file upload
  source = axios.CancelToken.source();

  created() {
    if (this.term) {
      this.termData = Object.assign({}, this.term);
      if (this.termData.attachments) {
        this.attachmentsNumber += this.termData.attachments.length;
      }
    }
  }

  mounted() {
    this.$nextTick(function() {
      this.editor_ref.focus();
      this.input_ref.focus();
    });
  }

  showAttachments() {
    console.log(this.attachmentsNumber);
  }

  pasteCapture(evt: any) {
    let text;
    let onPasteStripFormattingIEPaste;
    evt.preventDefault();
    const windowRef = window as any;
    const editorRef = this.$refs.editor_ref as QEditor;

    if (evt.originalEvent && evt.originalEvent.clipboardData.getData) {
      text = evt.originalEvent.clipboardData.getData("text/plain");
      editorRef.runCmd("insertText", text);
    } else if (evt.clipboardData && evt.clipboardData.getData) {
      text = evt.clipboardData.getData("text/plain");
      editorRef.runCmd("insertText", text);
    } else if (windowRef.clipboardData && windowRef.clipboardData.getData) {
      if (!onPasteStripFormattingIEPaste) {
        onPasteStripFormattingIEPaste = true;
        editorRef.runCmd("ms-pasteTextOnly", text);
      }
      onPasteStripFormattingIEPaste = false;
    }
  }

  addAttachments(file: any) {
    this.file = file;

    const newAttachment: TermAttachment = {
      ...defaultTermAttachment,
      filename: file.file.name,
      file: "data:application/pdf;base64," + file.base64,
    };

    if (this.attachmentsNumber < 3) {
      this.attachments.push({ ...newAttachment });
      this.attachmentsNumber += 1;
    }
  }

  onUploadProgress(progressEvent: ProgressEvent) {
    const { loaded, total } = progressEvent;
    this.progress = Math.floor((loaded * 100) / total);
  }

  async onSubmit() {
    if (this.attachments.length !== 0) {
      this.showProgress = true;
    }

    try {
      this.loading = true;
      let termToAdd: any = {
        ...this.termData,
        attachments: this.attachments,
        removedAttachments: this.removedAttachments,
        _cancelToken: this.source.token,
      };

      if (this.termData.sections) {
        termToAdd = {
          ...termToAdd,
          sections: this.termData.sections.map(section => section.name),
        };
      }

      if (this.term) {
        await TermsManagementModule.store.updateTerm({ term: termToAdd, onUploadProgress: this.onUploadProgress });
      } else {
        await TermsManagementModule.store.addTerm({ term: termToAdd, onUploadProgress: this.onUploadProgress });
      }

      notifySuccess("Operazione avvenuta con successo!");
      this.$emit("ok", true);
      this.termData = { ...defaultTerm };
      this.file = null;
      this.hide();
    } catch (thrown) {
      if (axios.isCancel(thrown)) {
        notifyError("Il caricamento del file è stato interrotto");
      } else {
        notifyError(`Si è verificato un errore durante la ${this.term ? "modifica" : "creazione"} del termine`);
      }
    } finally {
      this.loading = false;
      if (this.attachments.length > 0) {
        this.resetAttachments;
      }
    }
  }

  async onDeleteAttachment(attachment: TermAttachment, index: number) {
    this.attachments = this.attachments.filter((_, attIndex) => attIndex !== index);
    this.attachmentsNumber -= 1;
    this.file = null;
    this.filePicker.reset();

    if (attachment.term_id !== undefined) {
      this.removedAttachments.push(attachment.id);
    }
  }

  get columns() {
    return [
      {
        name: "filename",
        label: "Nome File",
        align: "left",
        field: "filename",
      },
      { name: "delete", align: "center" },
    ];
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  resetAttachments() {
    this.attachments = [];
    this.showProgress = false;
    this.progress = 0;
    this.source.cancel();
  }

  onCancelClick() {
    this.hide();
    this.resetAttachments();
  }

  onDialogHide() {
    this.$emit("hide");
  }

  get allAttachments() {
    if (this.termData.attachments) {
      return [
        ...this.attachments,
        ...this.termData.attachments.filter(attachment => !this.removedAttachments.includes(attachment.id)),
      ];
    }

    return [...this.attachments];
  }
}
